import { getFileAttributes } from '../..';
export var createDownloadButtonClickedEvent = function createDownloadButtonClickedEvent(fileState) {
  var _getFileAttributes = getFileAttributes(fileState),
    fileId = _getFileAttributes.fileId,
    fileMediatype = _getFileAttributes.fileMediatype,
    fileMimetype = _getFileAttributes.fileMimetype,
    fileSize = _getFileAttributes.fileSize;
  return {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'downloadButton',
    attributes: {
      fileAttributes: {
        fileId: fileId,
        fileMediatype: fileMediatype,
        fileMimetype: fileMimetype,
        fileSize: fileSize
      },
      fileProcessingStatus: fileState.status
    }
  };
};